import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../config/apiRouting';
import authenticatedFetch from '../../utils/authenticatedFetch';

interface Props {
  workflowId: string;
  onSaved: () => void;
}

export const FollowUpLogger: React.FC<Props> = ({ workflowId, onSaved }) => {
  const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
  const [method, setMethod] = useState('phone');
  const [outcome, setOutcome] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await authenticatedFetch(API_ENDPOINTS.recoveryFollowUp(workflowId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, method, outcome, notes })
      });
      if (response.ok) {
        onSaved();
      }
    } catch (err) {
      console.error('Failed to log follow-up:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="follow-up-form" onSubmit={handleSubmit} style={{ padding: '12px 20px', borderTop: '1px solid #e5e7eb', background: '#f9fafb' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
        <div>
          <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Date</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} style={{ width: '100%', padding: '6px 8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px' }} />
        </div>
        <div>
          <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Method</label>
          <select value={method} onChange={e => setMethod(e.target.value)} style={{ width: '100%', padding: '6px 8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px' }}>
            <option value="phone">Phone</option>
            <option value="in_person">In Person</option>
            <option value="email">Email</option>
          </select>
        </div>
        <div>
          <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Outcome</label>
          <select value={outcome} onChange={e => setOutcome(e.target.value)} style={{ width: '100%', padding: '6px 8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px' }}>
            <option value="">Select...</option>
            <option value="positive">Positive - Guest satisfied</option>
            <option value="neutral">Neutral - Acknowledged</option>
            <option value="negative">Negative - Still unhappy</option>
            <option value="no_answer">No answer</option>
          </select>
        </div>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Notes</label>
        <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Brief notes about the conversation..." rows={2} style={{ width: '100%', padding: '6px 8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit', resize: 'vertical' }} />
      </div>
      <button type="submit" disabled={saving || !outcome} style={{ background: '#8b5cf6', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', fontSize: '13px', cursor: 'pointer', opacity: saving || !outcome ? 0.5 : 1 }}>
        {saving ? 'Saving...' : 'Save Follow-Up'}
      </button>
    </form>
  );
};
